<template>
  <div class="progress-box-wrapper d-flex align-items-center mr-2">
    <div class="progress-box d-none d-lg-block pt-1">
      <span class="font10 font-600 mx-2">Onboarding in progress...</span>
      <span v-if="!loading" class="ml-1 mr-2 font12 font800"
        >{{ onboardingProgress }}%</span
      >
      <v-progress-linear
        v-if="!loading"
        class="mt-1"
        :value="onboardingProgress"
        height="4px"
      ></v-progress-linear>
      <v-progress-linear
        v-else
        indeterminate
        :color="primaryColor"
      ></v-progress-linear>
    </div>
    <v-progress-circular
      v-if="loading"
      indeterminate
      :color="primaryColor"
      class="d-flex d-lg-none"
    ></v-progress-circular>
    <CircularProgressBar
      v-else
      :onboardingProgress="onboardingProgress"
      :color="primaryColor"
    />
  </div>
</template>
<script>
import { objectsForEach } from '@/helpers/common';
import CircularProgressBar from './CircularProgressBar';
export default {
  name: 'OnboardingProgressBar',
  data() {
    return {
      onboardingProgress: 0,
      totalSelections: 0,
      loading: true
    };
  },
  components: { CircularProgressBar },
  computed: {
    primaryColor() {
      return this.$vuetify?.theme?.themes?.light?.primary;
    }
  },
  mounted() {
    this.getOnboardingProgress();
    // To assign color to the stroke of circular progress bar
    const circularOverlay = document.querySelector('.v-progress-circular__overlay');
    circularOverlay && (circularOverlay.style.stroke = this.primaryColor);
  },
  methods: {
    // To get onboarding progress percentage
    async getOnboardingProgress() {
      try {
        const syncResponse = await this.$services.onboarding.onboardingOrg(
          this.currentlySelectedOrgId,
          'poll'
        );
        const syncData = syncResponse?.data?.response;
        const selections = objectsForEach(syncData?.selections || {});
        // to calculate total selected onboarding jobs
        selections.map(
          selection => selection?.isSelected && this.totalSelections++
        );
        const progressRatio =
          (syncData?.status?.currentOnboardingState || 0) /
          this.totalSelections;
        const multiplier = 100;
        this.onboardingProgress = isNaN(progressRatio)
          ? 0
          : Math.round(progressRatio * multiplier) ?? 0;
        this.loading = false;
      } catch (error) {
        this.snackbar('error', error);
      }
    }
  }
};
</script>
<style scoped>
.progress-box {
  background-color: #5ae2c24d;
}
.progress-box-wrapper {
  border-right: 0.5px solid #1b234233;
  height: 48px;
  padding: 0 20px;
}
@media (max-width: 1264px) {
  .progress-box-wrapper {
    padding: 0 16px;
  }
}
</style>
